import { useMutation } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type UseDeleteCampaignProps = Readonly<{
  campaignId: string | undefined
  onDeleted: () => void
  onError: (error: Record<'code' | 'message' | 'title', string>) => void
}>

export type UseDeleteCampaignReturn = Readonly<{
  isLoading: boolean
  deleteCampaign: () => void
}>

const defaultError = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useDeleteCampaign = ({
  campaignId,
  onDeleted,
  onError
}: UseDeleteCampaignProps): UseDeleteCampaignReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: deleteCampaign }] = useMutation(
    workplaceGivingService.deleteGivingCampaign,
    () => {
      onDeleted()
    },
    error => {
      if (error) {
        onError(error.response?.data?.error ?? defaultError)
      }
    }
  )

  return {
    isLoading,
    deleteCampaign: () => {
      if (campaignId) {
        deleteCampaign(campaignId)
      }
    }
  }
}
